module.exports = __webpack_public_path__ + "img/about_us_bg.76b812e3.jpg";